const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    poolRequests: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveId: null,
});

export default {
    getInitialState
};
